import axios from 'axios';
//import { DEFAULT_HEADER, API_URL, JWT_TOKEN, JWT_REFRESH_TOKEN, WORKER_ID, CS_ID } from '../../const';
import LoginApi from '../../api/LoginApi';
import { DEFAULT_HEADER, JWT_REFRESH_TOKEN, JWT_TOKEN } from '../../const';
import store from '../../store/modules/facemapping';
const API_URL = process.env.API_URL;
//import authHeader from '../../api/Header';
// If you need global defaults, use:
//axios.defaults.baseURL = '/api';
//axios.defaults.headers.common['Accept-Encoding'] = 'gz';
// ...

// TODO: if we need, use a serverinfo,
// TODO: and if question, account Client same setting, they must be used together.

export const httpClient = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    //  timeout: 3000,
    headers: {
        ...DEFAULT_HEADER
    }
});

httpClient.interceptors.response.use(undefined, async function(error) {
    const originalRequest = error.config;
    const res = error.response ? error.response : null;
    store.state.isLoading = false;

    if (res.status === 401) {
        const result = await LoginApi.refreshToken(localStorage.getItem(JWT_REFRESH_TOKEN));
        //router.push()
        if (result.content) {
            localStorage.setItem(JWT_TOKEN, result.content.token.token);
            localStorage.setItem(JWT_REFRESH_TOKEN, result.content.token.refreshToken);
            originalRequest.headers['Authorization'] = result.content.token.token;
            return httpClient.request(error.config);
        }
    }
    if (error) {
        const message = error.response.data ? error.response.data.msg : httpErrorMessage(status);
        //return { message, status };
        //if (message && status !== 401) alert(i18n.t('error.' + error.data.code));
        if (message && status !== 401) {
            alert(message);
            location.replace(window.location.pathname + '#/login');
        }
    }
    return false;
});

/* http 연동관련 에러메세지 */
const httpErrorMessage = status => {
    switch (status) {
        case 400:
            return 'Bad Request';
        case 401:
            return 'Unauthorized';
        case 404:
            return 'Not Found';
        case 405:
            return 'Method Not Allowed';
        case 406:
            return 'Token Error';
        case 500:
            return 'Inter Server Error';
        default:
            return false;
        //return 'Error, please try again later';
    }
};

export const httpClientOnlyRefresh = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    timeout: 3000,
    headers: {
        ...DEFAULT_HEADER
    }
});

export const uploadClient = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
});

export const downloadClient = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
        ...DEFAULT_HEADER
    },
    responseType: 'blob'
});
